/** Recettes empilement : nb plis → épaisseur nominale (aligné backend empilement_populations.py) */

export const PLIS_TO_MM_LABEL = {
  14: "15 mm",
  20: "22 mm",
  28: "30 mm",
  30: "32 mm",
};

export const PLIS_TO_NOMINAL_MM = {
  14: 15,
  20: 22,
  28: 30,
  30: 32,
};

export const PLIS_RECONNUS = [14, 20, 28, 30];

export function isRecettePlis(nb) {
  return PLIS_RECONNUS.includes(Number(nb));
}

export function plisPopulationBucket(nbplis) {
  const n = Number(nbplis);
  return isRecettePlis(n) ? String(n) : "autre";
}

export function plisPopulationLabel(nbplis) {
  if (nbplis == null || nbplis === "") return "n/c";
  const mm = PLIS_TO_MM_LABEL[Number(nbplis)];
  return mm ? `${nbplis} plis / ${mm}` : `${nbplis} plis`;
}

/** Filtres UI type « 15 mm — 14 plis » */
export const PLIS_FILTER_OPTIONS = [
  { id: "14", label: "15 mm — 14 plis" },
  { id: "20", label: "22 mm — 20 plis" },
  { id: "28", label: "30 mm — 28 plis" },
  { id: "30", label: "32 mm — 30 plis" },
];

/** Boxplot gain massique (clés API by_pop) */
export const GAIN_MASSIQUE_POP_OPTIONS = [
  { id: "15mm", label: "15 mm — 14 plis" },
  { id: "22mm", label: "22 mm — 20 plis" },
  { id: "30mm", label: "30 mm — 28 plis" },
  { id: "32mm", label: "32 mm — 30 plis" },
];

/** Libellés courts boxplot gain massique */
export const GAIN_MASSIQUE_POP_LABELS = {
  "15mm": "15 mm (14 plis)",
  "22mm": "22 mm (20 plis)",
  "30mm": "30 mm (28 plis)",
  "32mm": "32 mm (30 plis)",
};
